function getParam(paramName, url) {
  const href = url || window.location.href;
  const name = paramName.replace(/[[]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(href);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function camelizeStr(str) {
  return str.replace(/[_.-](\w|$)/g, (_, x) => x.toUpperCase());
}

function snakifyStr(str) {
  return str.replace(/(?:^|\.?)([A-Z])/g, (_, x) => `_${x.toLowerCase()}`);
}

function convertCase(convertFunc) {
  function converter(thing) {
    if (thing instanceof Array) {
      return thing.map(i => converter(i));
    } else if (thing instanceof Object) {
      const newObj = {};
      Object.keys(thing).forEach((k) => {
        newObj[convertFunc(k)] = converter(thing[k]);
      });
      return newObj;
    }
    return thing;
  }
  return converter;
}

function copyHtml() {
  let str = document.getElementById('report_content').innerHTML;
  str = "<style>.block{text-align:left;clear:left}.headline{background-color:#c5c3cd;font-weight:700}.product{border-collapse:collapse;border-spacing:0;margin:20px 0;display:inline-block;float:left}.product-header{width:100%;border:2px solid;background-color:#fed35b;font-weight:700;height:100px;text-align:center;width:inherit;display:flex}.header-img-wrapper{width:0}.header-title{width:100%;padding:40px 0}.title-col{position:relative}.product-img{height:80px;margin-left:10px;margin-top:10px}.region-table{display:table;border-collapse:collapse;box-sizing:border-box}.region-row{display:table-row}.region-rank{display:table-cell;border:2px solid}.region-table{border-collapse:collapse}.region-cell{border:1px solid;text-align:center}.region{background-color:#fff0c6}.store{padding:2px 5px}.apple{background-color:#dce7f1}.google{background-color:#e1ebd6}.link{text-decoration:underline}.highlight-ranking{background-color:#06ff02}.ranking{margin:20px 0;width:100%;border-collapse:collapse}.center{text-align:center;vertical-align:middle}.rank-header{background-color:#eee}.rank-cell{border:1px solid #ccc;text-align:center;border-spacing:0}.app-cell{border:1px solid #ccc;border-spacing:0;max-width:240px;position:relative;overflow:hidden}.app-inner{padding:10px 16px 7px 10px;display:flex;flex-direction:row;text-align:left;justify-content:flex-start;background:url(../assets/img/iap.png) no-repeat;background-size:15px}.icon-block{min-width:34px;margin-right:10px}.app-icon{height:34px}.main-block{display:flex;margin:0;padding:0;flex-grow:1;flex-direction:row;overflow:hidden}.name-block{flex:1;display:flex;overflow:hidden;padding-right:20px;flex-direction:column;text-overflow:ellipsis;overflow:hidden}.app-name-container{height:23px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.company-name-container{height:19px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.app-link{color:#102235;font-size:13px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;text-decoration:none}.company-link{color:#999;font-size:12px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;text-decoration:none}.name-block a:hover{text-decoration:underline}.rank-block{min-width:4rem;text-align:center;padding:10px 0}.super-up{background-image:url(https://static-s.aa-cdn.net/media/pictures/ui/icons.v-88168f47.png);background-position:-3px -1040px;width:10px;height:16px;display:inline-block}.change-up{color:#6a6}.change-down{color:#a66}.iap-block{position:absolute;top:-8px;left:-8px;width:20px;height:20px;background:#fff;color:#51a250;border:1px solid #51a250;border-radius:100%}.iap-info{padding:1px 3px 0;font-size:8px;font-style:normal;line-height:9px;background:#fff;color:#51a250;font-family:Helvetica,'ProximaNova-Regular',Helvetica,Arial,sans-serif;position:absolute;right:1px;bottom:1px;border:none;background:transparent}</style>" + str;

  function listener(e) {
    e.preventDefault();
    e.clipboardData.setData("text/html", str);
  }
  document.addEventListener("copy", listener);
  document.execCommand("copy");
  document.removeEventListener("copy", listener);
}

export default {
	camelizeStr,
  getParam,
  snakifyStr,
  camelizeKeys: convertCase(camelizeStr),
  snakifyKeys: convertCase(snakifyStr),
  copyHtml,
};
